import { Component, Input, OnInit } from '@angular/core';
import { UmbracoStandardPageModel } from '@features/page/page.models';
import { GtmService } from '@core/services/gtm/gtm.service';
import { StoresComponent } from '../stores/stores.component';

@Component({
    selector: 'app-stores-overview',
    template: ` <section class="container block">
        <div class="wrapper">
            <h1>{{ data?.name }}</h1>
            <app-stores [storesImages]="data?.properties?.storesImages"></app-stores>
        </div>
    </section>`,
    styleUrls: ['./stores-overview.component.scss'],
    imports: [StoresComponent]
})
export class StoresOverviewComponent implements OnInit {
    public static ref = 'storesOverviewPage';

    @Input() data?: UmbracoStandardPageModel;

    constructor(private readonly gtmService: GtmService) {}

    public ngOnInit(): void {
        this.gtmService.trackFindStore();
    }
}
